/**
 * Stable id for this browser profile. Not a credential: it only tells the
 * API that two tabs on this computer are the same device, so a second
 * computer cannot silently reuse the HttpOnly session cookies.
 */
const STORAGE_KEY = "sales.device_id";
const DEVICE_ID_RE = /^[A-Za-z0-9_-]{16,128}$/;

let memoryId: string | null = null;

function randomDeviceId(): string {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
}

function readStored(storage: Storage): string | null {
  try {
    const existing = storage.getItem(STORAGE_KEY);
    return existing && DEVICE_ID_RE.test(existing) ? existing : null;
  } catch {
    return null;
  }
}

function writeStored(storage: Storage, value: string): boolean {
  try {
    storage.setItem(STORAGE_KEY, value);
    return true;
  } catch {
    return false;
  }
}

export function deviceId(): string {
  const fromLocal = typeof localStorage !== "undefined" ? readStored(localStorage) : null;
  if (fromLocal) return fromLocal;
  const fromSession = typeof sessionStorage !== "undefined" ? readStored(sessionStorage) : null;
  if (fromSession) return fromSession;
  if (memoryId) return memoryId;
  const created = randomDeviceId();
  if (typeof localStorage !== "undefined" && writeStored(localStorage, created)) return created;
  if (typeof sessionStorage !== "undefined" && writeStored(sessionStorage, created)) return created;
  memoryId = created;
  return created;
}

export function deviceHeaders(): Record<string, string> {
  return { "X-Device-Id": deviceId() };
}
